module.exports = __webpack_public_path__ + "assets/8906262bc04f19ca71d47704e0652b34.png";